import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/Navbar/Navbar';
import TopBar from '../../components/TopBar/TopBar';
import Footer from '../../components/Footer/Footer';
import { MdErrorOutline } from 'react-icons/md';

const NotFound = () => {
    return (
        <div className="min-h-screen flex flex-col font-sans">
            
            
            <main className="flex-grow flex items-center justify-center bg-gray-50 py-20 px-4">
                <div className="max-w-xl w-full text-center">
                    <div className="mb-8 flex justify-center">
                        <div className="relative">
                            <MdErrorOutline className="text-9xl text-[#ed3137] opacity-20" />
                            <span className="absolute inset-0 flex items-center justify-center text-8xl font-black text-[#021d53] tracking-tighter">
                                404
                            </span>
                        </div>
                    </div>
                    
                    <h1 className="text-4xl md:text-5xl font-black text-[#021d53] mb-6 uppercase tracking-tight">
                        Page Not Found
                    </h1>
                    
                    <div className="w-20 h-1 bg-[#ed3137] mx-auto mb-8"></div>
                    
                    <p className="text-xl text-gray-600 mb-12 leading-relaxed font-medium">
                        The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
                    </p>
                    
                    <Link 
                        to="/" 
                        className="inline-block bg-[#021d53] text-white px-12 py-5 rounded-full font-black text-lg hover:bg-[#ed3137] transition-all transform hover:scale-105 shadow-xl hover:shadow-2xl"
                    >
                        BACK TO HOME
                    </Link>
                </div>
            </main>
            
            <Footer />
        </div>
    );
};

export default NotFound;
